<template>
  <div>
    <SPreloader />
    <SLandingTopBar />
    <div class="header-spacer"></div>
    <div class="container">
      <div class="row mb-3">
        <div
          class="col col-xl-6 col-lg-7 col-md-12 col-sm-12 col-12 pt-5 pb-5 mt-3"
        >
          <div class="login-warning">
            <img src="/img/lock-icon.png" class="lock-icon" alt="Lock" />
            <h1 class="mb-3 page-title login-text">
              Please log in or register to continue
            </h1>
          </div>
        </div>
        <div class="login-content">
          <SLoginCard title="Log in to access" :redirectTo="redirectTo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SLandingTopBar from "@/material-components/organisms/SLandingTopBar.vue";
import SPreloader from "@/components/organisms/SPreloader.vue";
import SLoginCard from "@/components/organisms/SLoginCard.vue";

export default {
  name: "LoginRedirect",
  components: {
    SLandingTopBar,
    SPreloader,
    SLoginCard,
  },
  data() {
    return {
      redirectTo: null,
    };
  },
  methods: {
    deleteLastInteractionTime() {
      localStorage.removeItem("last_interaction");
    },
  },
  created() {
    if (this.$route.query.redirect)
      this.redirectTo = this.$route.query.redirect;

    this.deleteLastInteractionTime();
  },
};
</script>

<style lang="scss" scoped>
.page-title {
  color: $primary;
  font-style: normal;
  font-weight: 500 !important;
  line-height: 50px;
  letter-spacing: 1.7px;
  font-size: 34px;
  text-align: center;
}
.lock-icon {
  margin: auto;
  display: block;
  width: 100px;
  padding-bottom: 1.5rem;
}

.login-content {
  // margin-top: 80px;
  margin: auto;
  width: 25.67rem;
  height: 28rem;
}

.login-text{
  color: rgba(0, 0, 0, 0.6) !important
}

@media screen and (min-width: 1024px) {
  .login-content {
    margin-top: 80px;
  }
}
@media screen and (max-width: 1023px) {
  .login-warning {
    display: none;
  }
}
</style>
